import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-divider',
  templateUrl: './formly-divider.component.html',
  styleUrls: [],
})
export class FormlyDividerComponent extends FieldType {}
